import React, { useState } from 'react';
import cn from 'classnames';
import ExpandPanel from 'components/UI/ExpandPanel';
import Content from '../Content';
import { useTrans } from 'utils/localisation';
import * as commonStyles from '../TabList.module.scss';
import * as styles from './MobileTabs.module.scss';

function MobileTabs({ items, selectedTab, setSelectedTabHandler, visibleTabs = 6 }) {
  const t = useTrans(['common']);

  const [tabs, setTabs] = useState([...items].slice(0, visibleTabs));
  const [shortList, setShortList] = useState(true);

  const listLengthToggle = () => {
    shortList ? setTabs(items) : setTabs([...items].slice(0, visibleTabs));
    setShortList(prevState => !prevState);
  };

  return (
    <div className={styles.wrapper}>
      {tabs.map((tab, i) => {
        const { title } = tab;
        const isOpened = selectedTab === tab || i === 0;
        return (
          <div key={title} onClick={() => setSelectedTabHandler(tab)} className={commonStyles.tab}>
            <ExpandPanel title={title} isOpened={isOpened} theme="tabList">
              <div className={cn(styles.content, i === tabs.length - 1 && styles.last)}>
                <Content {...tab} />
              </div>
            </ExpandPanel>
          </div>
        );
      })}
      {items.length > visibleTabs && (
        <button
          onClick={listLengthToggle}
          className={cn(styles.toggleListButton, !shortList && styles.showLess)}
        >
          {shortList ? t('showMore') : t('showLess')}
        </button>
      )}
    </div>
  );
}

export default MobileTabs;
